module.exports = __webpack_public_path__ + "static/media/Logo_Merck_fr.e39b96c7.svg";